export default {
  // define all the getters
  showInvitePopup(state) {
    return state.showInvitePopup;
  },
  showCreateDashboardPopup(state) {
    return state.showCreateDashboardPopup;
  },
  showDashboardSharePopup(state) {
    return state.showDashboardSharePopup;
  },
  showVerifyEmailPopup(state) {
    return state.showVerifyEmailPopup;
  },
  showWindowSelectionPopup(state) {
    return state.showWindowSelectionPopup;
  },
  showComputedPropertyCreationPopup(state) {
    return state.showComputedPropertyCreationPopup;
  },
  showConsoleDetailsPopup(state) {
    return state.showConsoleDetailsPopup;
  },
  showGridLookupPopup(state) {
    return state.showGridLookupPopup;
  },
};
